import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/app/App";
import { guardarIndicacaoDaUrl } from "@/lib/indicacao";
import "./index.css";

guardarIndicacaoDaUrl();

const root = document.getElementById("root");
if (!root) throw new Error("#root nao encontrado no index.html");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
